export const Currencies={
    "ngn":1,
    "ghs":2,
    "kes":3,
    "inr":7,
    "php":29,
    "zar":35,
    "xof":51,
}